<template>
    <div class="CourseSingupModalWarp">
        <!-- 显示报名 -->
        <el-dialog title="" :visible.sync="showVisible" width="1200px" class="dialogWarp" @closed="offmodalFn" :destroy-on-close="true"
            :close-on-click-modal='false' :append-to-body="true">
            <div class="singupdialogcenter">
                <div class="stepsBox">
                    <el-steps :active="active" align-center finish-status="success">
                        <el-step title="填写报名信息"></el-step>
                        <el-step title="完善报名信息"></el-step>
                        <el-step title="上传文件"></el-step>
                    </el-steps>
                </div>
                <!-- v-if='!flagShow' -->
                <div class="singupForm" style="margin: 40px 0 30px 0">
                    <!-- label-position="left" -->
                    <el-form :model="firstFormData" ref="firstFormData" :rules='formRules' label-width="108px" class="demo-dynamic">
                        <el-form-item label="姓名" prop="userName">
                            <el-input placeholder="请输入姓名" v-model="firstFormData.userName" :disabled="userNameFlag"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号" prop="cardId">
                            <el-input placeholder="请输入身份证号" v-model="firstFormData.cardId" :disabled="cardIdFlag"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="phone">
                            <el-input placeholder="请输入联系电话" v-model="firstFormData.phone" :disabled="phoneFlag"></el-input>
                        </el-form-item>
                        <el-form-item label="工作单位名称" prop="workUnit">
                            <el-input placeholder="请输入工作单位名称" v-model="firstFormData.workUnit" :disabled="workUnitFlag"></el-input>
                        </el-form-item>
                        <div class="formBtnBox">
                            <!-- <el-button @click="submitdraftFn" class="submitdraftBtn">保存</el-button> -->
                            <el-button type="primary" @click="submitForm('firstFormData')" class="submitBtn" :loading="isloading">下一步</el-button>
                            <el-button @click="offmodalFn" class="cancelBtn">取消</el-button>
                        </div>
                    </el-form>
                </div>
                <!-- <div v-else class="submitSuccessBox">
                    <img src="@/assets/imgs/lead/success.png" class="img">
                    <div class="text1" v-if="!isUser">
                        您已填写成功！
                    </div>
                    <div class="text1" v-else>
                        您已提交成功！
                    </div>
                    <div class="text2" v-if="!isUser">
                        需要请您注册为中国人才交流协会网站用户，才能将信息提交至审核！
                    </div>
                    <div v-else>
                        <div class="text2" v-if="!islogin">
                            协会管理员将会联系您，核对报名信息并确认报名情况，为方便您查收审核结果请进行登录！
                        </div>
                        <div class="text2" v-else>
                            协会管理员将会联系您核对报名信息并确认报名情况
                        </div>
                    </div>
                    <div class="btnbox" @click="closeFn" v-if="!isUser">
                        确定
                    </div>
                    <div v-else>
                        <div class="formBtnBox" v-if="!islogin">
                            <div class="formBtnBox">
                                <el-button type="primary" @click="loginFn" class="submitBtn">登录</el-button>
                                <el-button @click="cancelFn" class="cancelBtn">取消</el-button>
                            </div>
                        </div>
                        <div class="btnbox" v-else @click="closeFn">
                            确定
                        </div>
                    </div>

                </div> -->
            </div>

        </el-dialog>
    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import { formErrorScroll } from '@/utils'
export default {
    props: {
        singupVisible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showVisible: true,
            active: 0,
            // 报名表单
            firstFormData: {
                userName: null,
                cardId: null,
                phone: null,
                workUnit: null,
            },
            formRules: {
                userName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                cardId: [
                    { required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                phone: [
                    {
                        required: true, message: '手机号码不能为空', trigger: 'blur'
                    },
                    {
                        required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
                    }
                ],
                workUnit: [
                    {
                        required: true, message: '工作单位名称不能为空', trigger: 'blur'
                    }
                ],
            },
            isloading: false,
            flagShow: false,
            isUser: false,
            islogin: sessionStorage.getItem('token'),
            resultData: null,
            phoneFlag: false,
            userNameFlag: false,
            cardIdFlag: false,
            workUnitFlag: false,
        }
    },
    mounted() {
        if (this.islogin) {
            this.selectLeaderPersonNoeFn()
            // this.firstFormData.phone=JSON.parse(sessionStorage.getItem('userInfo')).phoneNumber
        }
    },
    // watch: {
    //     // 监听 addOrUpdateVisible 改变
    //     singupVisible(oldVal, newVal) {
    //         this.showVisible = this.singupVisible
    //         console.log( this.showVisible,' this.showVisible弹框值');
    //         // console.log(this.showVisible,'this.showVisible');
    //         // console.log(oldVal, newVal,'oldVal, newVal预审');
    //     },
    //     deep: true,// 深度监听（例如对象中的数据）
    //     immediate: true//立即执行监听
    // },
    methods: {
        selectLeaderPersonNoeFn() {
            httpService.GooseselectLeaderPersonNoe().then(res => {
                if (res.code == 200) {
                    this.firstFormData = {
                        phone: res.result.phone,
                        userName: res.result.userName,
                        cardId: res.result.cardId,
                        workUnit: res.result.workUnit,
                    }
                    if (res.result.phone) {
                        this.phoneFlag = true
                    }
                    // if (res.result.userName) {
                    //     this.userNameFlag = true
                    // }
                    if (res.result.cardId) {
                        this.cardIdFlag = true
                    }
                    // if (res.result.workUnit) {
                    //     this.workUnitFlag = true
                    // }
                }
            })
        },
        // 报名表单
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isloading = true
                    // this.firstFormData.status = 0
                    this.firstFormData.auditResult = 1
                    // console.log(this.firstFormData,'this.firstFormData');
                    // return
                    httpService.GooseaddLeaderTalent(this.firstFormData).then(res => {
                        if (res) {
                            this.isloading = false
                            if (res.code == 200) {
                                let result = res.result
                                // this.flagShow = true //12-19修改
                                if (result.code === "201") {
                                    this.isUser = false
                                } else {
                                    this.isUser = true
                                }
                                if (res.result.result) {
                                    this.resultData = {
                                        userName: res.result.result.userName,
                                        password: res.result.result.password
                                    }
                                }
                                // console.log(
                                //     // 报名处
                                // );
                                // return
                                // 已有账户未登录
                                if (res.result.result) {
                                    this.$destroy(this.$emit('changeShowFirst', false, this.isUser, this.resultData))
                                } else {
                                    // 没有账号需要注册并登录
                                    this.$destroy(this.$emit('changeShowFirst', false, this.isUser, this.firstFormData))  // this.flagShow = true //12-19修改
                                }
                                // this.getyetFormFn()
                                // sessionStorage.setItem('downloadFile', res.result)
                                // this.$emit('update:isShow', false)
                                // if (!this.isCustom) this.$destroy(this.$emit('offseconfModal', true)) // 销毁当前组件

                            } else {
                                this.$message.error(res.message);
                            }
                        }
                    })
                } else {
                    this.$nextTick(() => {
                        formErrorScroll()
                    })
                    return false;
                }
            });
        },
        // // 存为草稿
        // submitdraftFn() {
        //     // this.firstFormData.status = 0//0草稿
        //     this.firstFormData.auditResult = 0
        //     httpService.addLeaderTalent(this.firstFormData).then(res => {
        //         if (res.code == 200) {
        //             this.$message({
        //                 message: '保存成功',
        //                 type: 'success'
        //             });
        //             // this.getyetFormFn()
        //             // this.$emit('update:isShow', false)
        //             // // this.$emit('offseconfModal', true)
        //             // if (!this.isCustom) this.$destroy() // 销毁当前组件
        //         } else {
        //             this.$message.error(res.message);
        //         }
        //     })
        // }
        // ,

        resetForm(formName) {
            this.firstFormData = {
                userName: null,
                cardId: null,
                phone: null,
                workUnit: null,
            }
        },
        // 关闭表单
        offmodalFn() {
            this.resetForm('firstFormData')
            this.flagShow = false

            this.$destroy(this.$emit('changeShowFirst', '关闭'))
            // this.$emit('offseconfModal',true)
            // if (!this.isCustom) this.$destroy() // 销毁当前组件
        },
        // 确定
        closeFn() {
            this.flagShow = false
            // this.$emit('update:isShow', false)
            // this.$emit('offseconfModal',true)
            this.$destroy(this.$emit('changeShowFirst', false, this.isUser, this.firstFormData))
            // if (!this.isCustom) this.$destroy() // 销毁当前组件
        },
        loginFn() {
            this.resetForm('firstFormData')
            this.flagShow = false

            this.$destroy(this.$emit('changeShowFirst', false, this.isUser, this.resultData))
        },
        cancelFn() {
            this.resetForm('firstFormData')
            this.flagShow = false
            this.$destroy(this.$emit('changeShowFirst', false, this.isUser)) // 销毁当前组件
        },
    }

}
</script>
<style lang="less" scoped>
// 课程相关
.dialogWarp {
	/deep/.singupdialogcenter {
		padding: 0px 0px 0px 0px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		align-items: center;
		.courseBox1 {
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding-bottom: 32px;
			border-bottom: 1px solid #dddddd;
			margin-bottom: 20px;
			.courseinfo {
				margin: 0 100px;
				font-size: 16px;
				line-height: 54px;
				color: #333333;
				.text {
					font-size: 16px;
					margin-right: 20px;
					line-height: 54px;
					color: #a6a9b7;
				}
			}
		}
		/deep/.el-checkbox__inner {
			border-radius: 50%;
		}
		.stepsBox {
			width: 100%;
		}
		/deep/.singupForm {
			width: 60%;
			margin: 40px 0 30px 0;
			.singupInfowarp {
				padding-bottom: 32px;
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				// padding: 0 82px;
			}
			.singupInfobox {
				// padding-bottom: 32px;
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				padding: 0 50px;
				.header {
					margin-bottom: 12px;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
					}
				}
				// .honor {
				// 	// margin-left: 20px;
				// 	position: relative;
				// 	&::before {
				// 		position: absolute;
				// 		top: 16px;
				// 		left: -10px;
				// 		// margin-right: 4px;
				// 		color: #ff4d4f;
				// 		font-size: 16px;
				// 		font-family: SimSun, sans-serif;
				// 		line-height: 1;
				// 		content: '*';
				// 	}
				// }
				.btnwarp {
					font-size: 16px;
					// line-height: 54px;
					display: flex;
					flex-direction: row;
					justify-content: center;

					.icon {
						margin-right: 5px;
					}
					.addbtn {
						color: #0083ff;
						margin: 0 20px;
						cursor: pointer;
					}
					.deletebtn {
						color: #ff3c3c;
						margin: 0 20px;
						cursor: pointer;
					}
				}
			}
			.header {
				font-size: 18px;
				line-height: 54px;
				color: #333333;
				.education {
					font-size: 16px;
					line-height: 54px;
					color: #999999;
					padding-left: 6px;
				}
			}
			.educationInfoBox {
				.header {
					margin-left: 48px;
				}
				// border-bottom: 1px solid #dddddd;
				// margin-bottom: 20px;
				// padding: 0 0px 30px 0px;
			}
			.makeoutInfoBox {
				border-bottom: 1px solid #dddddd;
				margin-bottom: 20px;
				padding: 0 50px 30px 50px;
				.header {
					font-size: 18px;
					line-height: 54px;
					color: #333333;
					.education {
						font-size: 16px;
						line-height: 54px;
						color: #999999;
						padding-left: 6px;
					}
				}
			}
		}
		.formBtnBox {
			display: flex;
			fill-opacity: row;
			justify-content: center;
			margin: 30px 0 0 0;
			.submitBtn {
				width: 152px;
				height: 40px;
				background: #349cff;
				margin: 0 20px;
			}
			.submitdraftBtn {
				width: 152px;
				height: 40px;
				background: #52ca9c;
				margin: 0 20px;
				color: #fff;
			}
			.cancelBtn {
				width: 152px;
				height: 40px;
				border: 1px solid #a6a9b7;
				border-radius: 5px;
				margin: 0 20px;
			}
		}
	}
	.yearbox {
		font-size: 15px;
		line-height: 40px;
		color: #a6a9b7;
		&::before {
			position: absolute;
			top: 12px;
			left: 0px;
			// margin-right: 4px;
			color: #ff4d4f;
			font-size: 16px;
			font-family: SimSun, sans-serif;
			line-height: 1;
			content: '*';
		}
	}
	.deteleIcon {
		font-size: 21px;
		cursor: pointer;
		color: red;
		line-height: 40px;
		margin-left: 4px;
	}
}
// /deep/.el-step__title.is-process {
// 	color: #349cff;
// }
// /deep/.el-step__head.is-process {
// 	color: #349cff;
// }
// /deep/.el-step__icon is-text {
// 	color: #349cff;
// 	border: 1px solid #349cff;
// 	border-radius: 0;
// 	transform: rotate(45deg);
// }
// /deep/.el-step__icon-inner {
// 	transform: rotate(-45deg);
// }
// /deep/.el-step__icon{
//     color: #349CFF;
//     border: 1px solid #349CFF;
// }

// 默认当前激活步骤显示的是黑色，这里修改显示为蓝色
::v-deep .el-step__head.is-process {
	color: #1890ff !important; // 圆圈中数字
	border-color: #1890ff !important; // 圆圈
}
::v-deep .el-step__title.is-process {
	color: #1890ff !important; // 圆圈下的标题文本
}
</style>


